module.exports = __webpack_public_path__ + "f2dc656eaeb005e4a891d169a8d63f8b.png";